function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  fill: "#EDEDED",
  width: 100,
  height: 130
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  fill: "#3B3835",
  width: 100,
  height: 17
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 10,
  y: 32,
  fill: "#929292",
  width: 80,
  height: 10
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 10,
  y: 52,
  fill: "#929292",
  width: 80,
  height: 10
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 10,
  y: 72,
  fill: "#929292",
  width: 80,
  height: 10
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 20,
  y: 105,
  fill: "#929292",
  width: 60,
  height: 5
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#75383B",
  d: "M260,178c0,1.1-0.9,2-2,2h-96c-1.1,0-2-0.9-2-2V52c0-1.1,0.9-2,2-2h96c1.1,0,2,0.9,2,2V178z"
}));

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 167,
  y: 60,
  fill: "#FFFFFF",
  width: 86,
  height: 110
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#929292",
  points: "223,53 223,43 197,43 197,53 193,53 193,67 227,67 227,53 "
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 175,
  y: 78,
  fill: "#929292",
  width: 50,
  height: 6
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#E76DB6",
  d: "M127.205,42.74l9.66,2.588l1.293-4.83c0.713-2.656-0.863-5.408-3.535-6.123 c-2.672-0.716-5.412,0.879-6.123,3.535L127.205,42.74z"
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 116.941,
  y: 42.705,
  transform: "matrix(-0.9659 -0.2588 0.2588 -0.9659 218.5867 192.1819)",
  fill: "#F9B233",
  width: 10.001,
  height: 77.999
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 125.999,
  y: 43.898,
  transform: "matrix(0.9659 0.2589 -0.2589 0.9659 16.864 -32.278)",
  fill: "#929292",
  width: 10.001,
  height: 7.999
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#3B3835",
  points: "109,130 112.488,125.76 108.1,124.583 "
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFBC80",
  points: "107.018,118.082 108.1,124.583 112.488,125.76 116.678,120.67 "
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#00ADC0",
  d: "M239,88c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S242.859,88,239,88z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "237.902,84.824 234.334,81.374 235.625,80.041 237.809,82.153 242.287,77.177 243.666,78.418  "
})));

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 175,
  y: 100,
  fill: "#929292",
  width: 50,
  height: 6
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#00ADC0",
  d: "M239,110c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S242.859,110,239,110z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "237.902,106.824 234.334,103.374 235.625,102.041 237.809,104.154 242.287,99.178  243.666,100.418  "
})));

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 175,
  y: 122,
  fill: "#929292",
  width: 50,
  height: 6
});

var _ref21 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#00ADC0",
  d: "M239,132c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S242.859,132,239,132z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "237.902,128.824 234.334,125.374 235.625,124.041 237.809,126.153 242.287,121.177  243.666,122.418  "
})));

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 175,
  y: 144,
  fill: "#929292",
  width: 50,
  height: 6
});

var _ref23 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#00ADC0",
  d: "M239,154c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S242.859,154,239,154z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "237.902,150.824 234.334,147.374 235.625,146.041 237.809,148.153 242.287,143.177  243.666,144.418  "
})));

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#6D6D6D",
  d: "M118.922,174.143H44.463v25.664c0,0,12.869,13.962,37.23,13.962c24.359,0,37.229-13.962,37.229-13.962 V174.143z"
});

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#333333",
  points: "81.693,141 14.002,166.385 81.693,191.769 149.385,166.385 "
});

var _ref26 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#D5007F",
  points: "10.617,183.307 17.387,183.307 14.002,166.385 "
});

var _ref27 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#DB2491",
  points: "127.385,251 127.385,213.769 132.799,213.769 137.537,251 132.463,246.295 "
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ED92C8",
  points: "127.385,251 127.385,213.769 121.969,213.769 117.23,251 122.307,246.295 "
});

var _ref29 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#E76DB6",
  points: "127.385,187.967 130.33,186.694 132.744,188.815 135.938,188.514 137.576,191.277 140.713,191.981  141.412,195.117 144.176,196.752 143.873,199.95 146,202.358 144.723,205.307 146,208.256 143.873,210.665 144.176,213.864  141.412,215.499 140.713,218.634 137.576,219.335 135.938,222.102 132.744,221.8 130.33,223.922 127.385,222.645 124.434,223.922  122.025,221.8 118.826,222.102 117.193,219.335 114.057,218.634 113.355,215.499 110.592,213.864 110.895,210.665 108.77,208.256  110.045,205.307 108.77,202.358 110.895,199.95 110.592,196.752 113.355,195.117 114.057,191.981 117.193,191.277 118.826,188.514  122.025,188.815 124.434,186.694 "
});

var _ref30 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#D5007F",
  d: "M140.922,205.307c0-7.479-6.061-13.538-13.537-13.538s-13.537,6.06-13.537,13.538 c0,7.48,6.061,13.539,13.537,13.539S140.922,212.787,140.922,205.307z"
});

var SvgQueEsObs02 = function SvgQueEsObs02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "260px",
    height: "251px",
    viewBox: "0 0 260 251",
    enableBackground: "new 0 0 260 251",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQueEsObs02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/queEsObs_02.78152817.svg";
export { ForwardRef as ReactComponent };